// extracted by mini-css-extract-plugin
module.exports = {"greyColor":"#d3d8dd","selectLabel":"MaterialSelect_selectLabel__14Pno"};